import { useField } from "formik";
import { EfsMelcoModelsColorListItem } from "melco-shared-logic";
import { useCallback } from "react";

export const useColorListIndex = () => {
  const [{ value: colors }] = useField<
    EfsMelcoModelsColorListItem[] | undefined
  >("color_list");

  return useCallback(
    (colorId: string) => {
      return colors?.findIndex((c) => c.id === colorId);
    },
    [colors]
  );
};
